import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  'light-tableRowRoot': {
    height: 65,
    cursor: 'pointer',
    backgroundColor: theme.colors.light_background,
    ...reskinStyles(theme, { backgroundColor: 'transparent' }),
    '&:hover': {
      backgroundColor: theme.colors.text_disabled,
      ...reskinStyles(theme, { backgroundColor: theme.colorPalette.beige_50 })
    }
  },
  'light-tableCellRoot': {
    fontSize: 14,
    color: theme.colors.light_text
  },
  'dark-tableRowRoot': {
    height: 65,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.colors.light_background,
      ...reskinStyles(theme, { backgroundColor: theme.colorPalette.beige_50 })
    }
  },
  'dark-tableCellRoot': {
    color: theme.colors.light_text,
    fontSize: 14
  },
  'dark-tableSortLabel': {
    color: theme.onCard.beige_50
  },
  'red-tableRowRoot': {
    height: 65,
    cursor: 'pointer',
    backgroundColor: theme.colors.red_dark,
    '&:hover': {
      backgroundColor: theme.colors.red
    },
    // These rows stay red or orange in the reskin, so their text stays light.
    ...reskinStyles(theme, { '& td': { color: theme.colorPalette.beige_50 } })
  },
  'red-tableCellRoot': {
    fontSize: 14,
    color: theme.colors.light_text
  },
  'orange-tableRowRoot': {
    height: 65,
    cursor: 'pointer',
    backgroundColor: theme.colors.notice_background,
    '&:hover': {
      backgroundColor: theme.colors.notice_background
    },
    // These rows stay red or orange in the reskin, so their text stays light; hover darkens the notice green.
    ...reskinStyles(theme, {
      '& td': { color: theme.colorPalette.beige_50 },
      '&:hover': { backgroundColor: theme.colorPalette.green_90 }
    })
  },
  'orange-tableCellRoot': {
    fontSize: 14,
    color: theme.colors.light_text
  },
  iconFold: {
    display: 'block',
    height: 32,
    width: 32,
    transition: 'transform 200ms'
  },
  icon: {
    composes: '$iconFold',
    transform: 'rotate(180deg)'
  },
  badge: {
    display: 'inline-flex',
    maxWidth: 24,
    backgroundColor: theme.colorPalette.green_90,
    textAlign: 'center',
    fontSize: 10,
    color: theme.colors.light_text,
    padding: theme.spacing(1, 2),
    borderRadius: theme.spacing(5),
    fontWeight: 'normal',
    ...reskinStyles(theme, { ...theme.labelStyles.outlined, maxWidth: 'none' })
  },
  headerLabel: {
    color: theme.onCard.beige_50,
    fontSize: 12,
    opacity: 0.6
  },
  collapserRowTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    fontSize: 16
  }
});

export default makeStyles(styles);
